import React, { Component } from 'react';
import { ClipboardDocumentIcon } from '@heroicons/react/20/solid';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Tooltip from '../components/SharedComponents/ToolTip';

class SmartPaste extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paste: false,
      showModal: false,
      smartPaste: '',
      isLoadingPaste: false,
      showTooltip: false
    };
    this.modalRef = React.createRef();
    this.handleSmartPaste = this.handleSmartPaste.bind(this);
  }

  toggleModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  handleClickOutside = (event) => {
    if (this.modalRef.current && !this.modalRef.current.contains(event.target)) {
      this.setState({ showModal: false });
    }
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  deidentifyText = (input) => {
    return input
      .replace(/\b[A-Z][a-z]+ [A-Z][a-z]+\b/g, '[Name]')
      .replace(/\b\d{1,2}[/-]\d{1,2}[/-]\d{2,4}\b/g, '[Date]')
      .replace(/\b\d{4,5}\s?[A-Z]?[a-z]+\s[A-Z]?[a-z]+\b/g, '[Address]')
      .replace(/\b\d{10,12}\b/g, '[Phone/ID]')
      .replace(/\b(?:Mr|Mrs|Ms|Dr)\.?\s[A-Z][a-z]+\b/g, '[Title Name]');
  };

  handleSmartPaste(event) {
    event.preventDefault();

    const pasteData = this.state.smartPaste;
    const cleanedData = this.deidentifyText(pasteData);

    toast.info('Deidentifying and processing...', {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 1000,
    });

    
    this.props.onPasteData(cleanedData);

    this.setState({ smartPaste: '' });
    this.toggleModal();
  }

  showTip = () => {
    this.setState({ showTooltip: true });
  };

  hideTip = () => {
    this.setState({ showTooltip: false });
  };

  render() {
    const { paste, showModal, smartPaste } = this.state;

    return (
      <div className="flex justify-center col-span-6 my-4">
        <button
          id="smartPaste"
          className={`${
            paste ? 'bg-red-600 hover:bg-red-700' : 'bg-sky-800 hover:bg-sky-900'
          } flex items-center text-white px-2 py-2 rounded-3xl`}
          onClick={this.toggleModal}
          onMouseEnter={this.showTip}
          onMouseLeave={this.hideTip}
        >
          <ClipboardDocumentIcon className="w-8 h-8" />
        </button>
        {this.state.showTooltip && <Tooltip text="Smart Paste" />}

        {showModal && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-start"
            onClick={this.toggleModal}
          >
            <div
              className="bg-white shadow-lg p-6 mt-20 w-[80%] rounded transform transition-transform duration-300 ease-in-out"
              onClick={(event) => event.stopPropagation()}
              ref={this.modalRef}
            >
              <div className="m-10 z-10">
                <div className="m-4">
                  <p className="text-md font-semibold mx-4 text-center">Smart Paste</p>
                  <form onSubmit={this.handleSmartPaste}>
                    <textarea
                      value={smartPaste}
                      onChange={(e) => this.setState({ smartPaste: e.target.value })}
                      className="w-full h-[500px] border-gray-200 resize-none"
                      placeholder="Paste Data here"
                    />
                    <button
                      className="text-white text-md my-2 p-4 w-full rounded shadow-lg bg-sky-800"
                      type="submit"
                    >
                      Process Data
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
        <ToastContainer />
      </div>
    );
  }
}

export default SmartPaste;
